import { render, staticRenderFns } from "./ClujiCardWrapper.vue?vue&type=template&id=31f31bdd"
import script from "./ClujiCardWrapper.vue?vue&type=script&lang=js"
export * from "./ClujiCardWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports